// 디자인 관리 섹션 URL (2026-08-18 KST 추가)
// 사이드바 메뉴와 라우팅이 같은 목록을 보도록 화면 트리를 여기서 한 번만 정의한다.
// children 이 있는 항목은 사이드바에서 펼쳐지고, 클릭하면 첫 하위 화면으로 이동한다. (2026-08-18 KST)
import urlJoin from "url-join";

const designSettingsSection = "/design/";

export const designSettingsPath = designSettingsSection;

export interface DesignSettingsPageNode {
  /** URL 경로 세그먼트 */
  id: string;
  label: string;
  children?: DesignSettingsPageNode[];
}

export const designSettingsPages: DesignSettingsPageNode[] = [
  { id: "basic", label: "기본 설정" },
  { id: "typography", label: "폰트/색상/버튼" },
  { id: "icons", label: "아이콘" },
  {
    id: "product-page",
    label: "상품 상세페이지",
    children: [
      { id: "settings", label: "상세페이지 설정" },
      { id: "info", label: "상세정보 안내" },
      { id: "banner", label: "상세페이지 배너" },
    ],
  },
  { id: "product-media", label: "상품 이미지 및 리스트" },
  {
    id: "banners",
    label: "배너 관리",
    children: [
      { id: "groups", label: "배너 그룹" },
      { id: "top", label: "메인 최상단 배너" },
      // 2026-08-27 KST: 자리만 잡아두었던 "주문/결제 배너" 를 전체 상품 페이지 배너로 바꿨다.
      // 2026-11-04 KST 수정: 페이지당 상품 수도 함께 정하므로 '전체 상품 배너' → '전체 상품 설정' → '전체 상품페이지'
      { id: "products", label: "전체 상품페이지" },
    ],
  },
  { id: "main-layout", label: "메인 레이아웃 관리" },
  // 2026-10-24 KST 추가: 푸터 로고·메뉴 자리를 HTML 로 바꾸는 설정
  { id: "footer", label: "푸터" },
];

export const designSettingsPageUrl = (...segments: string[]) =>
  urlJoin(designSettingsSection, ...segments);
